import { render, staticRenderFns } from "./plateList.vue?vue&type=template&id=299d4bf9&scoped=true&"
import script from "./plateList.vue?vue&type=script&lang=js&"
export * from "./plateList.vue?vue&type=script&lang=js&"
import style0 from "./plateList.vue?vue&type=style&index=0&id=299d4bf9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299d4bf9",
  null
  
)

export default component.exports